/* src/app/components/case/case-select/case-select.component.scss */
#cancel-search-button .mat-icon {
  color: #fff;
  fill: #fff;
  font-size: 18px;
  height: 18px;
  width: 18px;
  margin-top: 2px;
}
:host-context(.dark-theme) a,
:host-context(.dark-theme) a:visited {
  color: white;
}
/*# sourceMappingURL=case-select.component.css.map */
